(function() {

  function filterUnique(value, index, array) {
    return array.indexOf(value) === index
  }

  function filterProductOptions(product, options, key) {
    const available_options = product.variants
        ? product.variants
          .map(variant => variant[key])
          .map(value => value.toLowerCase())
          .filter(filterUnique)
        : []
      ;

      if (! available_options.length) {
        return options
      }

      return options.map(type => {
        type.disabled = ! available_options.includes(
          type.value.toLowerCase()
        )

        return type
      })
  }

  const SubscriptionLandingChoiceInput = function(Alpine, el, options = {}) {
    const { prop } = options

    Alpine.bind(el, () => {
      return {
        ['@click.prevent']() {
          if (this.value === prop[this.$data.prop_key]) {
            this.value = ''
          } else {
            this.value = prop[this.$data.prop_key]
          }
        },

        [':value']() {
          return prop[this.$data.prop_key]
        },

        [':class']() {
          return {
            'active' : this.value === prop[this.$data.prop_key],
            'disabled': true === prop['disabled']
          }
        },

        [':disabled']() {
          return true === prop['disabled']
        }
      }
    })
  }

  const SubscriptionLandingChoice = function(Alpine, el, options = {}) {
    Alpine.bind(el, () => {
      return {
        ['x-modelable']: 'value',
        ['x-data']() {
          return {
            value   : '',
            prop_key: options.prop_key || 'value'
          }
        }
      }
    })
  }

  const SubscriptionLanding = function(Alpine, el, options = {}) {
    Alpine.bind(el, () => {

      const VARIANT_OPTION_WEIGHT_NAME  = 'Size'
      const VARIANT_OPTION_GROUND_TYPE_NAME = 'Type'
      const VARIANT_OPTION_ROAST_TYPE_NAME = 'Roast'
      const VARIANT_OPTION_BLEND_TYPE_NAME = 'Blend'

      const VARIANT_OPTION_WEIGHT       = 'option1'
      const VARIANT_OPTION_ROAST_TYPE   = 'option2'
      const VARIANT_OPTION_GROUND_TYPES = 'option3'


      const ALLOCATION_DELIVERY_FREQUENCY_POSITION = 1
      const ALLOCATION_BILLING_FREQUENCY_POSITION = 2

      console.log(options)

      return {
        ['x-data']() {
          const {
            products,
            products_metadata,
            weights,
            roast_types,
            ground_types,
            delivery_frequencies
          } = options.data

          products.forEach((product, index) => {
            product.roast_type    = products_metadata[index].roast_type
            product.blend_type    = products_metadata[index].blend_type
            product.custom_handle = products_metadata[index].custom_handle
          })

          return {
            product: undefined,
            variant: undefined,
            allocation: undefined,

            values: {
              roast             : undefined,
              product           : undefined,
              weight            : undefined,
              ground_type       : undefined,
              delivery_frequency: undefined,
              // billing_frequency : '4 orders',
            },

            reset( values = [] ) {
              values.forEach(key => {
                this.values[key] = undefined
              })
            },

            init() {
              this.$watch( 'values.roast', () => {
                this.reset( [ 'product', 'weight', 'delivery_frequency', 'ground_type' ] )
              })

              this.$watch( 'values.product', () => {
                this.reset( [ 'weight', 'delivery_frequency', 'ground_type',  ] )
              })

              this.$watch( 'values.weight', () => {
                this.reset( [ 'delivery_frequency', 'ground_type',  ] )
              })

              this.$watch( 'values.delivery_frequency', () => {
                this.reset( [ 'ground_type' ] )
              })

              this.$watch( 'values', value => {
                this.product = value.product ? this.getProduct() : undefined
                this.variant = this.product && this.canCheckout() ? this.getVariant() : undefined
              })

              this.$watch( 'variant', value => {
                this.allocation = value ? this.getSellingPlan() : undefined
              })
            },

            canCheckout() {
              return !! this.values.roast
                && !! this.values.product
                && !! this.values.weight
                && !! this.values.ground_type
                && !! this.values.delivery_frequency
            },

            getCheckoutUrl(variant,  quantity) {
              if (! variant) {
                return ''
              }

              let url   = this.$app.$shopify.$vars( 'url' )
              let query = `?items[][id]=${variant.id}%26items[][quantity]=${quantity}`

              const discount = this.$store.coupon.value

              if ( this.allocation && this.allocation.selling_plan ) {
                query += `%26items[][selling_plan]=${this.allocation.selling_plan.id}`
              }

              query += `%26return_to=/checkout`

              if ( discount ) {
                query += `?discount=${discount}`
              }

              url += `/cart/clear?return_to=/cart/add${query}`

              return url
            },

            getSellingPlan() {
              if ( ! this.variant) {
                return undefined
              }

              if ( ! ( this.variant.selling_plan_allocations && this.variant.selling_plan_allocations.length ) ) {
                return undefined
              }

              return this.variant.selling_plan_allocations.find(allocation => {
                return this.values.billing_frequency
                  ? allocation.selling_plan.name.toLowerCase() === `${this.values.delivery_frequency.toLowerCase()} (${this.values.billing_frequency.toLowerCase()})`
                  : allocation.selling_plan.name.toLowerCase() === `${this.values.delivery_frequency.toLowerCase()}`
              })
            },

            getVariant() {
              if (! this.product) {
                return undefined
              }

              if (! this.product.variants) {
                return undefined
              }

              let variants = this.product.variants

              const blendIndex = this.product.options.indexOf(VARIANT_OPTION_BLEND_TYPE_NAME)
              const roastIndex = this.product.options.indexOf(VARIANT_OPTION_ROAST_TYPE_NAME)

              if (blendIndex >= 0) {
                variants = this.product.variants.filter((variant) => {
                  return variant.options[blendIndex].toLowerCase() === this.product.blend_type.toLowerCase()
                })
              }

              if (roastIndex >= 0) {
                variants = this.product.variants.filter((variant) => {
                  return variant.options[roastIndex].toLowerCase() === this.product.roast_type.toLowerCase()
                })
              }

              const weightIndex = this.product.options.indexOf(VARIANT_OPTION_WEIGHT_NAME)
              const groundIndex = this.product.options.indexOf(VARIANT_OPTION_GROUND_TYPE_NAME)

              const found = variants.find(variant => {
                return variant.options[weightIndex].toLowerCase() === this.values.weight.toLowerCase()
                  && variant.options[groundIndex].toLowerCase() === this.values.ground_type.toLowerCase()
                ;
              })


              console.log('groundIndex', groundIndex)
              console.log('weightIndex', weightIndex)
              console.log('variants', variants)
              console.log('found', found)
              console.log('values', this.values)

              return found
            },

            getProduct() {
              return this.getProductByHandle(this.values.product)
            },

            getProductByHandle(handle) {
              return handle ? products.find(product => product.custom_handle === handle) : undefined
            },

            getProducts() {
              if (! this.values.roast) {
                return []
              }

              const value = products.filter(product => {
                return this.getProductMetadata(product.custom_handle).roast_type.toLowerCase() === this.values.roast.toLowerCase()
              })

              return value
            },

            getProductMetadata(handle) {
              return products_metadata.find(product => handle === product.custom_handle)
            },

            getRoastTypeName() {
              return this.values.roast
                ? roast_types.find(roast => {
                    return roast.value.toLowerCase() === this.values.roast.toLowerCase()
                  }).text
                : ''
            },

            getRoastTypes() {
              const available_options = products
                .filter(product => {
                  return product.variants && product.variants.length
                })
                .reduce((prev, product) => {
                  const options = product.variants.reduce((prev, variant) => {
                    return prev.concat(variant[VARIANT_OPTION_ROAST_TYPE])
                  }, [])

                  return prev.concat(options)
                }, [])
                .filter(filterUnique)
                .map(value => value.toLowerCase())
              ;

              if (! available_options.length) {
                return roast_types
              }

              return roast_types.map(type => {
                type.disabled = ! available_options.includes(type.value.toLowerCase())

                return type
              })
            },

            getWeightName() {
              return this.values.weight
                ? weights.find(weight => {
                  return weight.value.toLowerCase() === this.values.weight.toLowerCase()
                }).text
                : ''
            },

            getWeights() {
              if (! this.values.product) {
                return []
              }

              const index = this.product.options.indexOf(VARIANT_OPTION_WEIGHT_NAME)

              if (0 > index) {
                return []
              }

              return filterProductOptions(this.product, weights, `option${index + 1}`)
            },

            getFrequencyName() {
              return this.values.delivery_frequency
                ? delivery_frequencies.find(frequency => {
                    return frequency.value.toLowerCase() === this.values.delivery_frequency.toLowerCase()
                  }).text
                : ''
            },

            getFrequencies() {
              if (! this.values.product) {
                return []
              }

              let available_options = []

              if ( this.product.selling_plan_groups ) {
                available_options = this.product.selling_plan_groups
                  .reduce((prev, group) => {
                    return prev.concat(
                      group.options.find(option => option.position === 1).values
                    )
                  }, [])
                  .filter(filterUnique)
                  .map(value => value.toLowerCase())
                ;
              }

              // In actuality, this should be empty, as there is no product for subscription available.
              if ( ! available_options.length) {
                return delivery_frequencies
              }

              return delivery_frequencies.map(type => {
                type.disabled = ! available_options.includes(type.value.toLowerCase())

                return type
              })
            },

            getGroundTypeName() {
              return this.values.ground_type
                ? ground_types.find(ground_type => {
                    return ground_type.value.toLowerCase() === this.values.ground_type.toLowerCase()
                  }).text
                : ''
            },

            getGroundTypes() {
              if (! this.values.product) {
                return[]
              }

              const index = this.product.options.indexOf(VARIANT_OPTION_GROUND_TYPE_NAME)

              if (0 > index) {
                return []
              }

              return filterProductOptions(this.product, ground_types, `option${index + 1}`)
            },
          }
        },
      }
    })
  }

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  window.addEventListener( 'alpine:init', function() {
    app.$alpine.directive( 'subscription-landing-choice', (el, { value, expression }, { evaluate }) => {
      const options = expression ? evaluate(expression) : {}

      if ( 'input' === value ) {
        SubscriptionLandingChoiceInput(app.$alpine, el, options)
      } else if ( ! value ) {
        SubscriptionLandingChoice(app.$alpine, el, options)
      }
    })

    app.$alpine.directive( 'subscription-landing', (el, { value, expression }, { evaluate }) => {
      const options = expression ? evaluate(expression) : {}

      if ( ! value ) {
        SubscriptionLanding(app.$alpine, el, options )
      }
    }).before( 'bind' )
  })
})()
